import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { setMessage } from '../message';
import LatihanServices from '../../services/latihanServices';
import { clearAuth } from 'store/auth';
import { isObject } from 'lodash';

export const getList = createAsyncThunk('latihan/list', async ({ type, query }, thunkAPI) => {
  try {
    const response = await LatihanServices.getList(type, query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getListArchive = createAsyncThunk('latihan/getListArchive', async ({ type, query }, thunkAPI) => {
  try {
    const response = await LatihanServices.getListArchive(type, query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getAlHistory = createAsyncThunk('latihan/getAlHistory', async (query, thunkAPI) => {
  try {
    const response = await LatihanServices.getAlHistory(query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const createData = createAsyncThunk('latihan/create', async (data, thunkAPI) => {
  try {
    const response = await LatihanServices.create({
      ...data,
      created_by: data.created_by === '' ? null : data.created_by,
      jenjang_id: data.jenjang_id === '' ? null : data.jenjang_id,
      mapel_id: data.mapel_id === '' ? null : data.mapel_id,
      bab_id: data.bab_id === '' ? null : data.bab_id
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const readData = createAsyncThunk('latihan/read', async (id, thunkAPI) => {
  try {
    const response = await LatihanServices.read(id);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const updateData = createAsyncThunk('latihan/update', async (data, thunkAPI) => {
  try {
    const response = await LatihanServices.update(data.id, {
      ...data,
      created_by: data.created_by === '' ? null : data.created_by,
      jenjang_id: data.jenjang_id === '' ? null : data.jenjang_id,
      mapel_id: data.mapel_id === '' ? null : data.mapel_id,
      bab_id: data.bab_id === '' ? null : data.bab_id
    });

    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteData = createAsyncThunk('latihan/delete', async (id, thunkAPI) => {
  try {
    const response = await LatihanServices.del(id);

    return response.data;
  } catch (error) {
    if (error.response.status == 401) {
      thunkAPI.dispatch(clearAuth());
    }

    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getHistory = createAsyncThunk('latihan/getHistory', async ({ latihanID, query }, thunkAPI) => {
  try {
    const response = await LatihanServices.getHistory(latihanID, query);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const sessionScore = createAsyncThunk('latihan/sessionScore', async (data, thunkAPI) => {
  try {
    const response = await LatihanServices.sessionScore(data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const changeStatus = createAsyncThunk('latihan/changeStatus', async (data, thunkAPI) => {
  try {
    const response = await LatihanServices.changeStatus(data.id, data);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue();
  }
});

export const getRatings = createAsyncThunk('latihan/getRatings', async ({ id, page, perPage, sort, orderBy }, thunkAPI) => {
  try {
    const response = await LatihanServices.getRatings(id, { page, perPage, sort, orderBy });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      thunkAPI.dispatch(clearAuth());
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const copyLatihan = createAsyncThunk('latihan/copy', async ({ id, name, createdBy = null }, thunkAPI) => {
  try {
    const response = await LatihanServices.copyLatihan(id, name, createdBy);
    thunkAPI.dispatch(setMessage({ message: 'Latihan berhasil disalin', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getShares = createAsyncThunk('latihan/getShares', async (latihanId, thunkAPI) => {
  try {
    const response = await LatihanServices.getShares(latihanId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getEligibleTeachers = createAsyncThunk('latihan/getEligibleTeachers', async (latihanId, thunkAPI) => {
  try {
    const response = await LatihanServices.getEligibleTeachers(latihanId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const getEligibleForCopy = createAsyncThunk('latihan/getEligibleForCopy', async (latihanId, thunkAPI) => {
  try {
    const response = await LatihanServices.getEligibleForCopy(latihanId);
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const addShares = createAsyncThunk('latihan/addShares', async ({ latihanId, teacherIds }, thunkAPI) => {
  try {
    const response = await LatihanServices.addShares(latihanId, teacherIds);
    thunkAPI.dispatch(setMessage({ message: response.message, type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

export const removeShare = createAsyncThunk('latihan/removeShare', async ({ latihanId, teacherId }, thunkAPI) => {
  try {
    const response = await LatihanServices.removeShare(latihanId, teacherId);
    thunkAPI.dispatch(setMessage({ message: response.message || 'Akses berhasil dicabut', type: 'success' }));
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) thunkAPI.dispatch(clearAuth());
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    thunkAPI.dispatch(setMessage({ message: message, type: 'error' }));
    return thunkAPI.rejectWithValue(error?.response?.data);
  }
});

const initialState = {
  isLoading: false,
  list: [],
  data: null,
  ratings: null,
  group: [],
  jawaban: [],
  sessionList: [],
  session: null,
  histories: null,
  shares: [],
  eligibleTeachers: [],
  eligibleForCopy: [],
  shareLoading: false,
  error: []
};

const latihanSlice = createSlice({
  name: 'latihan',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getList.pending, (state) => {
      state.isLoading = true;
      state.list = null;
    }),
      builder.addCase(getList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getList.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getListArchive.pending, (state) => {
        state.isLoading = true;
        state.list = null;
      }),
      builder.addCase(getListArchive.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      }),
      builder.addCase(getListArchive.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getAlHistory.pending, (state) => {
        state.isLoading = true;
        state.histories = null;
      }),
      builder.addCase(getAlHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.histories = action.payload;
      }),
      builder.addCase(getAlHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(createData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(createData.fulfilled, (state) => {
        state.isLoading = false;
        state.error = [];
      }),
      builder.addCase(createData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = isObject(action.payload.errors) ? action.payload.errors : [];
      }),
      builder.addCase(readData.pending, (state) => {
        state.isLoading = true;
        state.data = null;
      }),
      builder.addCase(readData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      }),
      builder.addCase(readData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(updateData.pending, (state) => {
        state.isLoading = true;
        state.error = [];
      }),
      builder.addCase(updateData.fulfilled, (state) => {
        state.isLoading = false;
        state.error = [];
      }),
      builder.addCase(updateData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = isObject(action.payload.errors) ? action.payload.errors : [];
      }),
      builder.addCase(deleteData.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(deleteData.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(deleteData.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getHistory.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.group = [];
        state.jawaban = [];
      }),
      builder.addCase(getHistory.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.latihan;
        state.group = action.payload.session;
        state.jawaban = action.payload.jawaban;
      }),
      builder.addCase(getHistory.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(sessionScore.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(sessionScore.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(sessionScore.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(changeStatus.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(changeStatus.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getRatings.pending, (state) => {
        state.isLoading = true;
        state.ratings = null;
      }),
      builder.addCase(getRatings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.ratings = action.payload;
      }),
      builder.addCase(getRatings.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(copyLatihan.pending, (state) => {
        state.isLoading = true;
      }),
      builder.addCase(copyLatihan.fulfilled, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(copyLatihan.rejected, (state) => {
        state.isLoading = false;
      }),
      builder.addCase(getShares.pending, (state) => {
        state.shareLoading = true;
        state.shares = [];
      }),
      builder.addCase(getShares.fulfilled, (state, action) => {
        state.shareLoading = false;
        state.shares = action.payload;
      }),
      builder.addCase(getShares.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(getEligibleTeachers.pending, (state) => {
        state.shareLoading = true;
        state.eligibleTeachers = [];
      }),
      builder.addCase(getEligibleTeachers.fulfilled, (state, action) => {
        state.shareLoading = false;
        state.eligibleTeachers = action.payload;
      }),
      builder.addCase(getEligibleTeachers.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(getEligibleForCopy.pending, (state) => {
        state.shareLoading = true;
        state.eligibleForCopy = [];
      }),
      builder.addCase(getEligibleForCopy.fulfilled, (state, action) => {
        state.shareLoading = false;
        state.eligibleForCopy = action.payload;
      }),
      builder.addCase(getEligibleForCopy.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(addShares.pending, (state) => {
        state.shareLoading = true;
      }),
      builder.addCase(addShares.fulfilled, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(addShares.rejected, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(removeShare.pending, (state) => {
        state.shareLoading = true;
      }),
      builder.addCase(removeShare.fulfilled, (state) => {
        state.shareLoading = false;
      }),
      builder.addCase(removeShare.rejected, (state) => {
        state.shareLoading = false;
      });
  }
});

const { reducer } = latihanSlice;
export default reducer;
